var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "tools" } },
    [
      _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "nav",
        { staticClass: "navbar fixted-top navbar-light bg-light sub-nav" },
        [
          _c("div", { staticClass: "navbar-brand" }, [_vm._v("Tools")]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "nav nav-pages mr-auto" },
            _vm._l(_vm.menu, function(item) {
              return _c("li", { key: item.id, staticClass: "nav-item" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link",
                    class: { active: _vm.checkActive(item.id) },
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.active = item
                      }
                    }
                  },
                  [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]
                )
              ])
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "container-fluid" }, [
            _vm.active.id === "summary"
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "row align-items-start",
                      staticStyle: { "margin-bottom": "25px" }
                    },
                    [
                      _c("div", { staticClass: "col-6" }, [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-heading" }, [
                            _vm._v(
                              "\n              Tool Migration Progress\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("ToolsMigrated", {
                                attrs: { toolsReport: _vm.tools }
                              })
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6" }, [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-heading" }, [
                            _vm._v(
                              "\n              Outdated Tool Versions\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("ToolsOutdatedVersion", {
                                attrs: {
                                  toolsOutdated: _vm.summary.outdated_versions,
                                  accounts: _vm.summary.accounts
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row align-items-start",
                      staticStyle: { "margin-bottom": "25px" }
                    },
                    [
                      _c("div", { staticClass: "col-8" }, [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-heading" }, [
                            _vm._v(
                              "\n              Bearse Features\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("ToolsBearseFeatures", {
                                attrs: {
                                  deployedFeatures: _vm.summary.bearse_features,
                                  accounts: _vm.summary.accounts,
                                  features: _vm.bearseFeatures
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-2" }, [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-heading" }, [
                            _c("div", [
                              _vm._v(
                                "Accounts Reporting (" +
                                  _vm._s(
                                    _vm.len(_vm.summary.reported_accounts)
                                  ) +
                                  " out of " +
                                  _vm._s(_vm.len(_vm.summary.accounts)) +
                                  " accounts)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("PercentageOfAccounts", {
                                attrs: {
                                  reported: _vm.len(
                                    _vm.summary.reported_accounts
                                  ),
                                  total: _vm.len(_vm.summary.accounts)
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-2" }, [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-heading" }, [
                            _c("div", [
                              _vm._v(
                                "Accounts Monitored (" +
                                  _vm._s(
                                    _vm.len(
                                      _vm.accountsMonitored(
                                        _vm.summary.accounts
                                      )
                                    )
                                  ) +
                                  " out of " +
                                  _vm._s(_vm.len(_vm.summary.accounts)) +
                                  " accounts)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("PercentageOfAccounts", {
                                attrs: {
                                  reported: _vm.len(
                                    _vm.accountsMonitored(_vm.summary.accounts)
                                  ),
                                  total: _vm.len(_vm.summary.accounts)
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row align-items-start",
                      staticStyle: { "margin-bottom": "25px" }
                    },
                    [
                      _c("div", { staticClass: "col-6" }, [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-heading" }, [
                            _vm._v(
                              "\n              Tools With Failed Cloudformation Stacks\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("ToolsFailedStacks", {
                                attrs: { stacks: _vm.summary.failed_stacks }
                              })
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6" }, [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-heading" }, [
                            _vm._v(
                              "\n              Tools With Failed Code Pipelines\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("ToolsFailedPipeline", {
                                attrs: {
                                  pipelines: _vm.summary.failed_pipelines
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  )
                ])
              : _vm.active.id === "bearse2"
              ? _c(
                  "div",
                  [
                    _c("BearseFeatures", {
                      attrs: {
                        report: _vm.tools[_vm.active.id],
                        features: _vm.bearseFeatures,
                        templates: _vm.tools.bearse2_templates,
                        accounts: _vm.summary.accounts,
                        accountsReporting: _vm.summary.reported_accounts
                      }
                    })
                  ],
                  1
                )
              : _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "row",
                      staticStyle: { "margin-bottom": "15px" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c(
                            "transition",
                            { attrs: { name: "fade", appear: "" } },
                            [
                              _c("div", { staticClass: "card" }, [
                                _c("div", { staticClass: "card-header" }, [
                                  _c("h5", [_vm._v(_vm._s(_vm.active.name))])
                                ]),
                                _vm._v(" "),
                                _vm.active.id !== "elmer"
                                  ? _c("div", { staticClass: "card-body" }, [
                                      _c("dl", [
                                        _c("dt", [_vm._v("Latest Version")]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.versions[_vm.active.id].latest
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("dt", [_vm._v("Minimum Version")]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.versions[_vm.active.id]
                                                .minimum
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("dt", [_vm._v("Source")]),
                                        _c("dd", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  _vm.versions[_vm.active.id]
                                                    .source
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.versions[_vm.active.id]
                                                    .source
                                                )
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("dt", [_vm._v("Open Source")]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.versions[_vm.active.id]
                                                .opensource
                                            )
                                          )
                                        ])
                                      ])
                                    ])
                                  : _vm._e()
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.active.id === "ciinabox2"
                        ? _c(
                            "div",
                            { staticClass: "col-4" },
                            [
                              _c(
                                "transition",
                                { attrs: { name: "fade", appear: "" } },
                                [
                                  _c("div", { staticClass: "card" }, [
                                    _c("div", { staticClass: "card-header" }, [
                                      _c("h5", [_vm._v("Jenkins Distribution")])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "card-body" }, [
                                      _c("dl", [
                                        _c("dt", [_vm._v("Latest Version")]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.versions[
                                                "jenkinsdistribution"
                                              ].latest
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("dt", [_vm._v("Minimum Version")]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.versions[
                                                "jenkinsdistribution"
                                              ].minimum
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("dt", [_vm._v("Source")]),
                                        _c("dd", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  _vm.versions[
                                                    "jenkinsdistribution"
                                                  ].source
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.versions[
                                                    "jenkinsdistribution"
                                                  ].source
                                                )
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("dt", [_vm._v("Open Source")]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.versions[
                                                "jenkinsdistribution"
                                              ].opensource
                                            )
                                          )
                                        ])
                                      ])
                                    ])
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.active.id === "ciinabox"
                        ? _c(
                            "div",
                            { staticClass: "col-4" },
                            [
                              _c(
                                "transition",
                                { attrs: { name: "fade", appear: "" } },
                                [
                                  _c("div", { staticClass: "card" }, [
                                    _c("div", { staticClass: "card-header" }, [
                                      _c("h5", [_vm._v("Jenkins")])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "card-body" }, [
                                      _c("dl", [
                                        _c("dt", [_vm._v("Latest Version")]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(_vm.versions.jenkins.latest)
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("dt", [_vm._v("Minimum Version")]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(_vm.versions.jenkins.minimum)
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("dt", [_vm._v("Source")]),
                                        _c("dd", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  _vm.versions.jenkins.source
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.versions.jenkins.source
                                                )
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("dt", [_vm._v("Open Source")]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.versions.jenkins.opensource
                                            )
                                          )
                                        ])
                                      ])
                                    ])
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.active.id === "ciinabox"
                        ? _c(
                            "div",
                            { staticClass: "col-4" },
                            [
                              _c(
                                "transition",
                                { attrs: { name: "fade", appear: "" } },
                                [
                                  _c("div", { staticClass: "card" }, [
                                    _c("div", { staticClass: "card-header" }, [
                                      _c("h5", [_vm._v("Docker Agent")])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "card-body" }, [
                                      _c("dl", [
                                        _c("dt", [_vm._v("Latest Version")]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.versions[
                                                "ciinaboxdockerslave"
                                              ].latest
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("dt", [_vm._v("Minimum Version")]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.versions[
                                                "ciinaboxdockerslave"
                                              ].minimum
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("dt", [_vm._v("Source")]),
                                        _c("dd", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  _vm.versions[
                                                    "ciinaboxdockerslave"
                                                  ].source
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.versions[
                                                    "ciinaboxdockerslave"
                                                  ].source
                                                )
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("dt", [_vm._v("Open Source")]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.versions[
                                                "ciinaboxdockerslave"
                                              ].opensource
                                            )
                                          )
                                        ])
                                      ])
                                    ])
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "transition",
                          { attrs: { name: "fade", appear: "" } },
                          [
                            _c("vue-good-table", {
                              attrs: {
                                columns: _vm.active.table,
                                rows: _vm.tools[_vm.active.id],
                                "search-options": {
                                  enabled: true,
                                  skipDiacritics: true,
                                  placeholder: "filter"
                                },
                                "pagination-options": {
                                  enabled: true,
                                  perPage: 20
                                },
                                styleClass: "vgt-table condensed"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bb62a91", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bb62a91","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tools.vue
// module id = null
// module chunks = 